(ns teamoesterreich.admin-mode.data.news
  (:require [teamoesterreich.ajax :as ajax]
            [goog.json :as json]
            [clojure.walk]

            [teamoesterreich.admin-mode.data.backend :as backend]
            [teamoesterreich.util.log :as log]))



(defn date-to-restDate [d]
  (let [t (clojure.string/replace (str (.toISOString d)) #"\.|:|-" "")]
    (str (subs t 0 15) "." (subs t 15))))

(defn >new-news [name finished-fn]
  (ajax/auth-post> (backend/get-auth)  (str  backend/BASE_URL "/news" )
              (ajax/serialize {:news-active true
                               :news-title name
                               :news-published false
                               :news-date (date-to-restDate (js/Date.))
                               :news-content ""})
              (fn [data status]
                (when (= status 200)
                  (finished-fn
                    (into {} (clojure.walk/keywordize-keys (js->clj (json/parse data))))
                    )))))


(defn >news-edit-img [news-uuid news-imageUri finished-fn]
  (ajax/auth-put> (backend/get-auth)  (str  backend/BASE_URL "/news/" news-uuid)
             (ajax/serialize (merge {:news-uuid news-uuid}
                                    {:news-imageUri news-imageUri}))
             finished-fn))

(defn >news-edit [news-uuid news finished-fn]
  (ajax/auth-put> (backend/get-auth)  (str  backend/BASE_URL "/news/" news-uuid)
             (ajax/serialize (merge news
                                    {:news-uuid news-uuid}))
             finished-fn))

(defn get-news-list [done-fn]
  (ajax/auth-get> (backend/get-auth) (str backend/BASE_URL "/news")
              (fn [r-list status]
                ;(log/debug "get-blog done" r-list status)
                (when (= status 200)
                  (done-fn
                    (into {} (map (fn [e] [(get e "news-uuid") (clojure.walk/keywordize-keys e)]) (js->clj (json/parse r-list))))
                    )))))

(defn get-news [blockUuid done-fn]
  (ajax/auth-get> (backend/get-auth) (str backend/BASE_URL "/news/" blockUuid)
              (fn [r-list status]
                ;(log/debug "get-blog done" r-list status)
                (when (= status 200)
                  (done-fn
                    (into {} (clojure.walk/keywordize-keys (js->clj (json/parse r-list))))
                    )))))
